export const mseApiDomain = () => {
  const isProxied = !!import.meta.env.VITE_PROXY_ENV;
  const mode = import.meta.env.MODE;
  const host = window?.location?.host || '';

  if (mode === 'development' && (!isProxied || host.includes('local'))) {
    return host;
  } else if (host === 'www.moneysavingexpert.com') {
    return 'prod-api.moneysavingexpert.com';
  } else if (host.includes('sit1')) {
    return 'test-api.moneysavingexpert.com';
  } else {
    return 'stage-api.moneysavingexpert.com';
  }
};
